import React, { type FC, useState } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import { Company, type Exam, type ExamParticipant, Project } from "../api/dto";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const RenameSubContractorModal: FC<{
  subcontractor: string;
  participants: ExamParticipant[];
  companyId: string;
  exams: Exam[];
}> = (props) => {
  const { updateSubContractor } = useApiCall();
  const { refresh } = useApi();
  const [name, setName] = useState(props.subcontractor);
  const sameNameSubContractors = props.participants.filter(
    (participant) =>
      participant.subContractor === name &&
      props.exams.some((exam) => exam.id === participant.examId),
  );
  const save = async () => {
    await updateSubContractor(props.companyId, name, props.subcontractor);
    await Promise.all([refresh.exams(true), refresh.participants(true)]);
  };
  return (
    <div>
      <Input type={"text"} label={"Naam"} value={name} onChange={setName} />
      {sameNameSubContractors.length > 0 && name !== props.subcontractor ? (
        <div
          className={
            "bg-amber-100 mt-4 border-2 border-amber-200 text-amber-900 mb-4 text-sm rounded-lg px-4 py-3"
          }
        >
          <h2 className={"font-bold"}>SubContractor samenvoegen</h2>
          Er zijn een andere examens met deze subcontractor binnen dit bedrijf, als je opslaat
          worden deze samengevoegd.
        </div>
      ) : (
        <></>
      )}
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
